import { Locale } from "./commonTypes";

export enum PreferenceType {
    PRODUCT = 'product',

    RECIPE = 'recipe',
    RECIPE_CHARACTERISTIC = 'recipe-characteristic',

    PROPERTY = 'property',
    MACRONUTRIENT_PER_DAY = 'macronutrient-per-day',
    MACRONUTRIENT_PER_MEAL = 'macronutrient-per-meal',
    PRODUCT_CATEGORY_PER_DAY = 'product-category-per-day',
    PRODUCT_CATEGORY_PER_MEAL = 'product-category-per-meal',

    CEREAL_MIX = 'cereal-mix',
    KASHA_CONSISTENCY = 'kasha-consistency',
    COMBINATION = 'combination',
}

export enum KashaConsistencyPreferenceItem {
    FLUFFY = 'kasha-consistency-fluffy',
    CREAMY = 'kasha-consistency-creamy',
    STICKY = 'kasha-consistency-sticky',
}

export enum PreferenceValueUnit {
    PERCENTAGE = 'percentage',
    GRAM = 'gram',
    G_PER_KG = 'g-per-kg',
    MG_PER_KG = 'mg-per-kg',
    MCG_PER_KG = 'mcg-per-kg',
    MG = 'mg',
    MCG = 'mcg',
}

export enum PreferenceWhen {
    MORNING = 'morning',
    AFTER_MORNING = 'after-morning',
    AFTERNOON = 'afternoon',
    BEFORE_EVENING = 'before-evening',
    EVENING = 'evening',
    NIGHT = 'night',
    NO_MATTER = 'no-matter',
}

export enum PreferenceFrequency {
    NO_MATTER= 'no-matter',
    ONCE_A_PERIOD = 'once-a-period',
    EVERY_DAY = 'everyDay',
    DAY_AFTER_DAY = 'dayAfterDay',
    ONCE_IN_DAYS = 'onceInDays',
}

export type PreferenceItemCode = {
    itemCode: string;
    value?: string;
    minValue?: number;
    maxValue?: number;
}

export type PreferencePhrase = {
    readonly id?: string;
    isGenerated?: boolean;
    content?: string;
    locale?: Locale;
    vote?: number;
    isWelcome?: boolean;
}

export type Group = {
    readonly id?: string;
    name?: string;
}

export type Phrase = {
    id?: string;
    content?: string;
    locale?: Locale;
    isNew?: boolean;
};

export type Preference = {
    readonly id?: string;
    include?: boolean;
    preferenceType?: PreferenceType;
    layerCode?: string;
    when?: PreferenceWhen;
    preferenceFrequency?: PreferenceFrequency;
    frequencyPeriod?: number;
    preferenceItemCodes?: PreferenceItemCode[];
    combinedPreferences?: Preference[];
    phrase?: PreferencePhrase[];
    dateCreated?: string;
    groups?: Group[];
    isChild?: boolean;
    isSelected?: boolean;
    count ?: number;
};
